
import { Header } from "@/components/layout/Header";
import { cn } from "@/lib/utils";
import { SetupGuideCTA } from "@/components/setup-guide/SetupGuideCTA";
import { useTheme } from "@/components/ThemeProvider";
import { useLocation } from "react-router-dom";
import { BugReportButton } from "@/components/admin/bug-reports/BugReportButton";
import { ScrollToTopButton } from "@/components/common/ScrollToTopButton";
import { DemoDataBanner } from "@/components/common/DemoDataBanner";

interface ShellProps {
  children: React.ReactNode;
  className?: string;
}

export function Shell({ children, className }: ShellProps) {
  const { theme } = useTheme();
  const location = useLocation();
  
  const is24SevenTheme = theme === "24seven";
  
  return (
    <div 
      className={cn(
        "min-h-screen flex flex-col transition-all duration-500 overflow-x-hidden", 
        "bg-background",
        {
          "bg-24seven-light": is24SevenTheme
        }
      )} 
      data-app-shell
    >
      <Header />
      
      <main
        className={cn(
          "flex-1 w-full max-w-full px-4 sm:px-6 lg:px-8 py-6 sm:py-8 animate-fade-in-up relative",
          className
        )}
        data-main-content
      >
        <div className="relative w-full">
          <DemoDataBanner />
          <div className="relative z-10 w-full">
            <div className="bg-card rounded-3xl shadow-sm border border-border/50 p-6 sm:p-8 lg:p-10">
              {children}
            </div>
          </div>
        </div>
      </main>
      <ScrollToTopButton />
      <BugReportButton />
      
    </div>
  );
}
